module.exports = __webpack_public_path__ + "img/pin-diamante-imperial.12bf3472.png";